

const OperationLogs = () => {
    return (
        <div className="p-6">
            <h1 className="text-2xl font-bold">Operation Logs</h1>
            <p>Content coming soon...</p>
        </div>
    );
};

export default OperationLogs;
